import { apiEndpoints } from 'src/config/api.config';
import { errorMessageMap } from 'src/config/errorMessage.config';
import { SubjectPayload, UnitPayload } from 'src/views/SubjectManagement/payload.model';

let ENV_VARS;

function bytesToSize(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

function getInitials(name = '') {
  name
    .replace(/\s+/, ' ')
    .split(' ')
    .slice(0, 2)
    .map(v => v && v[0].toUpperCase())
    .join('');
}

function setEnvVars(env) {
  ENV_VARS = env;
}

function getEnvVars() {
  return ENV_VARS;
}

function getAPIEndpoints(endpointName = '') {
  const ENV = getEnvVars()['ENV'];
  const apis = apiEndpoints[ENV];
  if (endpointName) return apis[endpointName];
  return apis;
}

function getDataFromSessionStorage(key, jsonParse = true) {
  let data = sessionStorage.getItem(key);
  if (jsonParse) data = JSON.parse(data);
  return data;
}

function setDataToSessionStorage(key, payload, jsonStringify = true) {
  if (jsonStringify) payload = JSON.stringify(payload);
  sessionStorage.setItem(key, payload);
}

function removeDataFromSessionStorage(keys, removeAll = false) {
  if (removeAll) {
    sessionStorage.clear();
    return;
  }

  if (Array.isArray(keys)) keys.forEach(key => sessionStorage.removeItem(key));
  else sessionStorage.removeItem(keys);
}

// have to remove this function
function generateSuperAdminHeader() {
  let userRoles = getDataFromSessionStorage('userRoles');
  let userInfo = getDataFromSessionStorage('userInfo');
  let superAdminIndex = userRoles.indexOf('SUPER_ADMIN');
  if (superAdminIndex !== -1) {
    userInfo.roles = userRoles[superAdminIndex];
  }
  return {
    userInfo: JSON.stringify(userInfo),
  };
}

function generateUiString(string, splitChar, joinChar, capitalCase) {
  if (splitChar) {
    string = string.split(splitChar);
    string = string.map(word => (capitalCase ? toCapitalCase(word) : word));
  }
  if (joinChar) {
    string = string.join(joinChar);
  }
  return string;
}

function toCapitalCase(word) {
  word = word.toLowerCase();
  word = word.split('');
  word[0] = word[0].toUpperCase();
  return word.join('');
}

function getQueryParams(url) {
  let queryParams = {};
  url = url.replace('?', '').split('&');
  for (let i = 0; i < url.length; i++) {
    let query = url[i].split('=');
    queryParams[query[0]] = query[1];
  }
  return queryParams;
}

function selectMultipleRows(event, subjects) {
  const selectedSubjects = event.target.checked
    ? // ? subjects.map(subject => subject[checkboxMap])
      subjects
    : [];
  return selectedSubjects;
}

function selectOneRow(subject, selectedSubjects, checkboxMap) {
  let selectedIndex;
  if (selectedSubjects.length) {
    for (let i = 0; i < selectedSubjects.length; i++) {
      if (selectedSubjects[i][checkboxMap] === subject[checkboxMap]) {
        selectedIndex = i;
        break;
      } else {
        selectedIndex = -1;
      }
    }
  } else {
    selectedIndex = -1;
  }
  // const selectedIndex = selectedSubjects.indexOf(subjectId);
  let newSelectedSubjects = [];

  if (selectedIndex === -1) {
    newSelectedSubjects = newSelectedSubjects.concat(selectedSubjects, subject);
  } else if (selectedIndex === 0) {
    newSelectedSubjects = newSelectedSubjects.concat(selectedSubjects.slice(1));
  } else if (selectedIndex === selectedSubjects.length - 1) {
    newSelectedSubjects = newSelectedSubjects.concat(selectedSubjects.slice(0, -1));
  } else if (selectedIndex > 0) {
    newSelectedSubjects = newSelectedSubjects.concat(
      selectedSubjects.slice(0, selectedIndex),
      selectedSubjects.slice(selectedIndex + 1)
    );
  }

  return newSelectedSubjects;
}

function generateSubjectUnitPayload(subjectsWithUnits, currentSubjectId) {
  let unitPayload = new UnitPayload();
  let payload = new SubjectPayload();

  let totalActiveUnits = 0; //
  let totalTopics = 0;
  let totalActiveTopics = 0; //

  let totalUnitActiveTopics = 0; //
  let totalSubTopics = 0;
  let totalActiveSubTopics = 0; //
  let totalUnitSubTopics = 0;
  let totalUnitActiveSubTopics = 0; //

  let totalVideoTime = 0;
  let totalActiveVideoTime = 0; //
  let totalUnitVideoTime = 0;
  let totalUnitActiveVideoTime = 0; //
  let totalTopicVideoTime = 0;
  let totalTopicActiveVideoTime = 0; //

  let totalFreeTrialSubTopics = 0;
  let totalUnitFreeTrialSubTopics = 0;

  let totalFreeTrialVideoTime = 0;
  let totalUnitFreeTrialVideoTime = 0;

  subjectsWithUnits
    .filter(subject => subject.subjectId === currentSubjectId)
    .slice(0, 1)
    .forEach(subjects => {
      const {
        units,
        subjectInfo: { subjectName },
        subjectId,
      } = subjects;
      payload.subjectName = subjectName;
      payload.subjectId = subjectId;
      payload.totalUnitsCount = units.length;
      units.forEach(unit => {
        totalUnitSubTopics = 0;
        totalUnitFreeTrialSubTopics = 0;
        totalUnitFreeTrialVideoTime = 0;
        const { topics, unitId, unitName, status, active, completion } = unit;

        if (unit.active) {
          totalActiveUnits++;
        }

        totalTopics += topics.length;
        unitPayload = new UnitPayload();
        // unitPayload.topics.push(...topics);
        unitPayload.topicsCount = topics.length;
        unitPayload.unitId = unitId;
        unitPayload.unitName = unitName;
        unitPayload.status = status;
        unitPayload.active = active;
        unitPayload.subjectId = subjectId;
        unitPayload.subjectName = subjectName;
        unitPayload.title = unitName;
        unitPayload.subtitle = subjectName;
        unitPayload.completion = completion;
        unitPayload.totalUnitActiveTopics = totalUnitActiveTopics; //
        unitPayload.totalUnitActiveSubTopics = totalUnitActiveSubTopics; //

        if (topics.length) {
          topics.forEach(topic => {
            const { contents } = topic;
            let topicCopy = shallowCloneObject(topic);

            if (topicCopy.active) {
              totalActiveTopics++;
              totalUnitActiveTopics++;
            }

            topicCopy.contents = [];
            topicCopy.subTopicsCount = 0;
            totalTopicVideoTime = 0;
            topicCopy.unitId = unitId;
            topicCopy.unitName = unitName;
            contents.forEach(content => {
              const { subTopic } = content;
              if (subTopic) {
                let subTopicCopy = shallowCloneObject(subTopic);
                subTopicCopy.activeVideoDuration = 0;

                if (subTopic.subtopicId && subTopicCopy.active) {
                  totalActiveSubTopics++;
                  totalUnitActiveSubTopics++;
                  totalTopicActiveVideoTime = totalTopicActiveVideoTime + subTopic.videoDuration;
                }

                subTopicCopy.topicId = topic.topicId;
                subTopicCopy.unitId = unitId;
                content.subTopic = subTopicCopy;
                topicCopy.contents.push(content);
                totalSubTopics++;
                totalUnitSubTopics++;
                // unitPayload.subTopics.push( subTopic );
                unitPayload.subTopicsCount++;
                totalTopicVideoTime = totalTopicVideoTime + subTopic.videoDuration;
                totalUnitVideoTime = totalUnitVideoTime + subTopic.videoDuration;
                totalVideoTime = totalVideoTime + subTopic.videoDuration;
                if (subTopic.active) {
                  totalActiveVideoTime = totalActiveVideoTime + subTopic.videoDuration;
                  totalUnitActiveVideoTime = totalUnitActiveVideoTime + subTopic.videoDuration;
                  subTopicCopy.activeVideoDuration = subTopic.videoDuration;
                }
                topicCopy.subTopicsCount++;
                if (subTopic.trial) {
                  totalFreeTrialVideoTime = totalFreeTrialVideoTime + subTopic.videoDuration;
                  totalUnitFreeTrialVideoTime =
                    totalUnitFreeTrialVideoTime + subTopic.videoDuration;
                  totalFreeTrialSubTopics++;
                  totalUnitFreeTrialSubTopics++;
                }
                unitPayload.subTopics.push(subTopicCopy);
              }
            });
            topicCopy.totalTopicVideoTime = totalTopicVideoTime;
            topicCopy.totalTopicActiveVideoTime = totalTopicActiveVideoTime; //
            totalTopicActiveVideoTime = 0;

            unitPayload.totalUnitActiveTopics = totalUnitActiveTopics; //
            unitPayload.totalUnitActiveSubTopics = totalUnitActiveSubTopics; //

            unitPayload.totalUnitSubTopics = totalUnitSubTopics;
            unitPayload.totalUnitFreeTrialSubTopics = totalUnitFreeTrialSubTopics;
            unitPayload.totalUnitFreeTrialVideoTime = totalUnitFreeTrialVideoTime;
            unitPayload.topics.push(topicCopy);
          });
        } else {
          unitPayload.totalUnitFreeTrialSubTopics = totalUnitFreeTrialSubTopics;
          unitPayload.totalUnitFreeTrialVideoTime = totalUnitFreeTrialVideoTime;
        }

        unitPayload.totalUnitVideoTime = totalUnitVideoTime;
        unitPayload.totalUnitActiveVideoTime = totalUnitActiveVideoTime;
        totalUnitVideoTime = 0;
        totalUnitActiveSubTopics = 0; //
        totalUnitActiveTopics = 0; //
        totalUnitActiveVideoTime = 0; //

        payload.units.push(unitPayload);
      });
    });

  payload.totalTopics = totalTopics;
  payload.totalSubTopics = totalSubTopics;
  payload.totalFreeTrialSubTopics = totalFreeTrialSubTopics;
  payload.totalFreeTrialVideoTime = totalFreeTrialVideoTime;
  payload.totalVideoTime = totalVideoTime;

  payload.totalActiveUnits = totalActiveUnits;
  payload.totalActiveTopics = totalActiveTopics;
  payload.totalActiveSubTopics = totalActiveSubTopics;
  payload.totalActiveVideoTime = totalActiveVideoTime;

  return payload;
}

function secondsToHrsMinsSecs(time, returnType = 'timeString') {
  let hrs = Math.floor(time / 3600);
  time = time - hrs * 3600;
  let mins = Math.floor(time / 60);
  time = time - mins * 60;
  let secs = time;

  if (returnType === 'timeString') return `${hrs} : ${mins} : ${secs}`;
  else if (returnType === 'array') return [hrs, mins, secs];
  else if (returnType === 'multi')
    return {
      timeStrin: `${hrs} : ${mins} : ${secs}`,
      array: [hrs, mins, secs],
    };
}

function handleApiError(err, metaData) {
  let token = getDataFromSessionStorage('authToken', false);
  let isAuthTokenValid = true;
  if (err?.response?.status === 401 && token && token !== null) {
    isAuthTokenValid = false;
  }
  // Section 1 : Here i can map custom UI error messages
  if (metaData) {
    const { replaceItems, alertAction, bannerAutoHideDuration } = metaData;
    let errorMessage = errorMessageMap[metaData.errorMessageMap];
    return {
      message: replaceItems
        ? replaceAllOccurrenceByObjectKey(errorMessage, replaceItems)
        : errorMessage,
      response: err,
      alertAction: alertAction,
      bannerAutoHideDuration: bannerAutoHideDuration,
      isAuthTokenValid: isAuthTokenValid,
    };
  }
  // Section 2 : Here i rely on backend to provide the error message
  if (err.response) {
    const { data, status } = err.response;
    let message;
    if (data && data.errorCode) {
      message = errorMessageMap[data.errorCode];
      message = message ? message : data.message;
    } else {
      message = data && data.message ? data.message : errorMessageMap[status];
    }
    return {
      message: message,
      response: err.response,
      isAuthTokenValid: isAuthTokenValid,
    };
  } else if (err.message === 'Network Error')
    return {
      message: errorMessageMap['netWorkError'],
      response: err,
      isAuthTokenValid: isAuthTokenValid,
    };
  else
    return {
      message: err,
      response: err,
      isAuthTokenValid: isAuthTokenValid,
    };
}

const trimmedText = text => {
  return text && text.length > 50 ? `${text}`.substring(0, 47) + '...' : `${text}`;
  // return text + text + text + text;
};

// Will add functionalities in the future for successMessage mapping.
function handleApiSuccess(response) {
  if (response && response.data) {
    return {
      message: response.data.message,
      response: response.data,
    };
  }
  return {
    message: response,
    response: response,
  };
}

// to be removed later
function handlePlainApiSuccess(response) {
  if (response.data) {
    return {
      message: response.data.message,
      response: response.data,
    };
  }
}

function copyDataBetweenObjects(source = {}, destination = {}) {
  for (let key in source) {
    // eslint-disable-next-line no-prototype-builtins
    if (destination.hasOwnProperty(key)) {
      destination[key] = source[key];
    }
  }
  return destination;
}

function shallowCloneObject(source, destination = {}) {
  for (let key in source) {
    destination[key] = source[key];
  }
  return destination;
}

function isUserAuthenticated() {
  let authToken = getDataFromSessionStorage('authToken', false);
  let userInfo = getDataFromSessionStorage('userInfo');

  if (authToken && userInfo) {
    return true;
  }

  return false;
}

function userHaveAccess(roleConfig = []) {
  let userRoles = getDataFromSessionStorage('userRoles');
  if (userRoles && Array.isArray(userRoles)) {
    for (let role of userRoles) {
      if (!roleConfig.length || roleConfig.indexOf(role) !== -1) {
        return true;
      }
    }
  }

  return false;
}

// Will be removed oncce backend starts cross checking the roles.
function generateUserInfoHeader(role) {
  let userRoles = getDataFromSessionStorage('userRoles');
  let userInfo = getDataFromSessionStorage('userInfo');
  if (role) {
    userInfo.roles = role;
  } else {
    if (userRoles.indexOf('CONTENT_ADMIN') !== -1) {
      userInfo.roles = userRoles[userRoles.indexOf('CONTENT_ADMIN')];
    } else if (userRoles.indexOf('CONTENT_DEVELOPER') !== -1) {
      userInfo.roles = userRoles[userRoles.indexOf('CONTENT_DEVELOPER')];
    }
  }
  return {
    userinfo: JSON.stringify(userInfo),
  };
}

function formatDateString(date) {
  return date.toISOString().replace('Z', '');
}

function formatDateFromISO(date) {
  date = date.concat('Z');
  let result = new Date(date);
  return new Date(result.toISOString());
}

function replaceAllOccurrenceByObjectKey(rawString, itemObject) {
  for (let key of Object.keys(itemObject)) {
    rawString = rawString.replace(`[${key}]`, itemObject[key]);
  }
  return rawString;
}

export function checkForEmptyKeys(payload) {
  for (let key in payload) {
    if (typeof payload[key] === 'object') {
      checkForEmptyKeys(payload[key]);
    } else {
      if (!payload[key]) {
        return true;
      }
    }
  }
  return false;
}

function checkProperties(obj) {
  for (var key in obj) {
    if (obj[key] !== null && obj[key] !== '') return false;
  }
  return true;
}

export function logForNonProdOnly(log) {
  if (getEnvVars()['ENV'] !== 'prod') console.log(log);
}

export function getNameInitials(name = '') {
  let words = name.split(' ');
  let initial = '';
  for (let word of words) {
    initial += word[0];
  }
  return initial;
}

export function generateUniqueStringFromObject(targetObject) {
  let targetString = '';
  for (let item in targetObject) {
    targetString += targetObject[item];
  }
  return targetString;
}

export function isSameObjectDataExists(newData, existingDataList = []) {
  let selectedObjectString = generateUniqueStringFromObject(newData);
  for (let i = 0; i < existingDataList.length; i++) {
    let uniqueString = generateUniqueStringFromObject(existingDataList[i]);
    if (selectedObjectString === uniqueString) {
      return {
        atIndex: i,
      };
    }
  }
  return false;
}

function toIndianCurrencyWithSymbol(number) {
  return number.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    style: 'currency',
    currency: 'INR',
  });
}

function toIndianCurrencyWithoutSymbol(number) {
  const valueInIndianFormat = new Intl.NumberFormat('en-IN').format(number);
  return valueInIndianFormat;
}

export function getFormattedDateAndTime(payload) {
  if (!payload) {
    return {
      dateString: '-',
      timeString: '',
    };
  }

  let months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  let time = new Date(payload);

  let date = time.getDate();
  let month = months[time.getMonth()];
  let year = time.getFullYear();

  let hours = time.getHours();
  let mins = time.getMinutes();
  let meridiem = 'AM';

  if (hours <= 12) {
    meridiem = 'AM';
  } else {
    meridiem = 'PM';
    hours = hours - 12;
  }

  if (mins < 10) {
    mins = `0${mins}`;
  }

  let dateString = `${date} ${month} ${year}`;
  let timeString = `${hours}:${mins}${meridiem}`;

  return {
    dateString: dateString,
    timeString: timeString,
  };
}

function removeSpecialCharacters(name) {
  // eslint-disable-next-line no-useless-escape
  return name.replace(/[`~!@#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
}

export function checkIsEmpty(obj) {
  let isEmpty = false;
  for (var key in obj) {
    // eslint-disable-next-line no-empty
    if (obj[key] !== null && obj[key] !== '') {
    } else {
      return true;
    }
  }
  return isEmpty;
}
export const randomNameGenerator = length => {
  let result = '';
  const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length - 1; i++)
    result += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));

  return result;
};

export {
  bytesToSize,
  getInitials,
  setEnvVars,
  getEnvVars,
  getAPIEndpoints,
  getDataFromSessionStorage,
  setDataToSessionStorage,
  removeDataFromSessionStorage,
  generateSuperAdminHeader,
  toCapitalCase,
  generateUiString,
  getQueryParams,
  selectMultipleRows,
  selectOneRow,
  generateSubjectUnitPayload,
  secondsToHrsMinsSecs,
  handleApiError,
  trimmedText,
  copyDataBetweenObjects,
  shallowCloneObject,
  isUserAuthenticated,
  generateUserInfoHeader,
  userHaveAccess,
  handleApiSuccess,
  handlePlainApiSuccess,
  replaceAllOccurrenceByObjectKey,
  formatDateString,
  formatDateFromISO,
  // checkKeyEmpty,
  checkProperties,
  toIndianCurrencyWithSymbol,
  toIndianCurrencyWithoutSymbol,
  removeSpecialCharacters,
};
